<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1" id="_idContainer001">
<p class="ORIM-Dedication--Front-Matter-" lang="en-US"><span class="CharOverride-3">For Mike, Agent and friend, and in memoriam</span></p>
<p class="ORIM-Dedication--Front-Matter-" lang="en-US"><span class="CharOverride-1">Anthea Joseph,</span></p>
<p class="ORIM-Dedication--Front-Matter-" lang="en-US"><span class="CharOverride-3">A kind and courageous lady</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// SeaLeopard1.vue?8b9384f4